'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _helper = {
	makeArray: function makeArray(value) {
		var arr = value.split(',');
		for (var i = 0; i < arr.length; i++) {
			arr[i] = arr[i].trim();
		}
		return arr;
	},
	transform: function transform(_transform) {
		return {
			'-webkit-transform': _transform,
			'-moz-transform': _transform,
			'-ms-transform': _transform,
			'transform': _transform
		};
	},
	transition: function transition(_transition) {
		return {
			'-webkit-transition': _transition,
			'-moz-transition': _transition,
			'-ms-transition': _transition,
			'transition': _transition
		};
	},
	shuffle: function shuffle(a) {
		var j, x, i;
		for (i = a.length; i; i -= 1) {
			j = Math.floor(Math.random() * i);
			x = a[i - 1];
			a[i - 1] = a[j];
			a[j] = x;
		}
	},
	resize: {
		columnsHeight: function columnsHeight($columns, rows) {
			/*
   make everyting in the same row the same hight
   the scripts recognizes self the rows
   Usage:
   _resize.columnsHeight('ul.columns li');
   */
			if ((typeof $columns === 'undefined' ? 'undefined' : _typeof($columns)) != 'object') {
				$columns = $($columns);
			}
			$columns.css({ 'height': 'auto' }).removeClass('resized');
			var itemsInRow = rows;
			column = 0;
			rowHeight = 0, first = true, total = $columns.length;
			if (rows == false || typeof itemsInRow == 'undefined') {
				itemsInRow = Math.floor($columns.parent().width() / $columns.first().outerWidth(true));
			}
			$columns.each(function (i) {
				column++;
				var itemHeight = $(this).height();
				if (rowHeight < itemHeight) {
					rowHeight = itemHeight;
				}
				if (column >= itemsInRow || i == total - 1) {
					column = 0;
					$(this).prevAll(':not(.resized)').addClass('resized').css({ 'height': rowHeight });
					$(this).addClass('resized').css({ 'height': rowHeight });
					rowHeight = 0;
				}
			});
		},
		video: function video($video, $proportion) {
			/*
   scale video in porportion
   Usage:
   _resize.video($('.video'), [16,9]);
   */
			if ((typeof $video === 'undefined' ? 'undefined' : _typeof($video)) != 'object') {
				$video = $($video);
			}
			$video.css({ 'height': 'auto', 'width': '100%' });
			var width = $video.width(),
			    height = Math.round(width / $proportion[0] * $proportion[1]);
			$video.css({ 'height': height });
		}
	}
};